module.exports = __webpack_public_path__ + "media/images/emblems/Commugny-coat_of_arms-ed0a138be57fd6b579024298ac6f19ce.svg";